<template>
	<div>
		<Top :showtop="2"></Top>
		<div class="wd-container">
			<div class="payinfo wd-flex wd-row-left">
				<div class="wd-img-80"><el-image src="../img/success.png"></el-image></div>
				<div class="wd-m-l-20 wd-m-t-20">
					<div class="wd-font-18 wd-success">购买成功，我们将尽快为您发货！</div>
					<div class="wd-m-t-20 wd-theme-666">
						订单号： {{ wddata.listseqno }} | 付款金额（元）：
						<span class="wd-theme wd-font-18 wd-font-bold">{{ wddata.allamount | amountFormatter }}元</span>
					</div>
					<div class="wd-m-t-20 wd-theme-999">重要提示：平台及销售商不会以订单异常、系统升级为由，要求您点击任何链接进行退款。</div>
					<div class="wd-m-t-40">
						<router-link class=" wd-cursor wd-theme" :to="{ name: 'Orderdetail', query: { posid: posid, orderno: listseqno } }" tag="span">查看订单详情</router-link>
						<span class="wd-m-l-20 wd-m-r-20 wd-theme-999">|</span>
						<router-link class=" wd-cursor wd-theme" :to="{ path: '/' }" tag="span">继续逛逛</router-link>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top from '@/components/layout/Top4.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Pay',
	components: {
		Top,
		Footer
	},
	data() {
		return {
			posid: '',
			wddata: '',
			listseqno: '',
			loaderror:false,
			payamount:0
		};
	},
	created() {
		let params = this.$route.query;
		this.posid = params.posid || '';
		this.listseqno = params.orderno || '';
		if (this.posid !== '' && this.listseqno !== '') {
			this.getpos();
		}else{
			this.$router.push({name:"Error"});
		}
	},
	methods:{
		getpos() {
			let indata = {
				posid: this.posid
			};
			this.$wd_request('poslist', indata, true)
				.then(data => {
					this.wddata = data.value;
				})
				.catch(data => {
					this.loaderror = true;
					this.$wd_toast(data.msg);
				});
		},
	}
};
</script>

<style lang="scss">
.payinfo {
	margin-top: 40px;
	border-top: 2px solid #7abd54;
	background-color: #f1f8ee;
	position: relative;
	padding-left: 66px;
	min-height: 116px;
	padding-bottom: 20px;
}
</style>
